import fi from "./fi";
import se from './se';
var dateTimeFormat = {
    date: { year: "numeric", month: "long", day: "numeric", hour12: false },
    time: { hour: "numeric", minute: "numeric", second: "numeric", hour12: false },
    full: {
        year: "numeric", month: "long", day: "numeric",
        hour: "numeric", minute: "numeric", second: "numeric", hour12: false
    }
};
var numberFormat = {
    currency: { style: "currency", currency: "EUR" }
};
export default {
    enabledLocales: ["fi", "se"],
    messages: { fi: fi, se: se },
    dateTimeFormats: {
        fi: dateTimeFormat,
        se: dateTimeFormat,
    },
    numberFormats: {
        fi: numberFormat,
        se: numberFormat,
    },
};



//////////////////
// WEBPACK FOOTER
// ./app/ts/i18n/index.ts
// module id = 77
// module chunks = 0